import Vue from 'vue'
import i18n from '~/plugins/i18n'
import { getActiveOrderId } from '~/helpers/active-order'

// The checkout steps all query the active order by id, so landing on one
// without an order (a direct link, a bookmark, a refresh after the order was
// cleared) left them rendering against nothing. Send the user back to the order
// summary with something readable instead.
//
// Read localStorage rather than the store: orders are fetched in mounted, so
// the getter is still empty on a hard refresh and would bounce a valid order.
export default (to, from, next) => {
  if (getActiveOrderId()) {
    next()
    return
  }

  Vue.$toast.warning(i18n.t('no_active_order_checkout'))
  next({ name: 'checkout-proceed.order-summary' })
}
